import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=accf0432&scoped=true"
import script from "./alert.ts?vue&type=script&lang=ts&external"
export * from "./alert.ts?vue&type=script&lang=ts&external"
import style0 from "./alert.scss?vue&type=style&index=0&id=accf0432&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accf0432",
  null
  
)

export default component.exports